/** Nouveaux secteurs — fusionné avec industries.ts (deep merge). */
export default {
  industries: {
    grocery: {
      name: 'Supermarchés & alimentaire',
      tagline: 'Conçu pour l’alimentaire',
      headline: 'Livraison par créneaux & routes denses pour',
      headlineHighlight: 'le retail frais',
      description:
        'Livraison jour même et planifiée avec créneaux, substitutions et routage IA pour forte densité d’arrêts, sans perdre la chaîne du froid.',
      heroKeyPoints: [
        'Créneaux clients et capacité fiables',
        'IA regroupe par zone pour moins de km par livraison',
        'Tracking de marque avec ETA live par panier',
        'Séquençage température pour frais et surgelés',
      ],
      stats: [
        { value: '35%', label: 'Plus de livraisons par tournée' },
        { value: '96%', label: 'Créneaux à l’heure' },
        { value: '50%', label: 'Moins d’appels WISMO' },
      ],
      painPoints: [
        { title: 'Promesses de créneaux sous volume', description: 'Les pics submergent les routes fixes — le client rate la fenêtre et part chez un concurrent.' },
        { title: 'Les substitutions érodent la confiance', description: 'Sans communication claire, les remplacements génèrent remboursements et avis négatifs.' },
        { title: 'Chaîne du froid au dernier kilomètre', description: 'Ambiant, frais et surgelé sur un même run exige du séquençage, pas de l’intuition.' },
      ],
      features: [
        { title: 'Moteur créneaux & capacité', description: 'Créneaux réservables selon flotte, temps de route et coupure préparation.', tag: 'IA' },
        { title: 'Routage priorité densité', description: 'Optimise arrêts/heure et ponctualité des créneaux, pas seulement la distance.', tag: 'IA' },
        { title: 'Messagerie substitutions', description: 'Notifier le client avant départ du chauffeur avec accepter/refuser clair.' },
        { title: 'Tracking live de marque', description: 'Page magasin avec ETA affinée et consignes de remise.' },
        { title: 'Séquençage température', description: 'Ordonne les arrêts pour limiter le temps hors véhicule au froid.' },
        { title: 'App chauffeur & POD', description: 'Scan à l’enlèvement, photo à la porte, contrôle d’âge si requis.' },
        { title: 'Analytics ops', description: 'Taux de remplissage des créneaux, coût par drop et heatmaps d’exceptions.' },
        { title: 'Sync POS & OMS', description: 'E-commerce, OMS et magasin dans un plan live.', tag: undefined },
      ],
      useCases: [
        'Supermarché jour même',
        'Hypermarché créneaux planifiés',
        'Dark store / quick commerce',
        'Chaînes régionales',
        'Tournées type meal kit',
        'Fourgons réassort B2B magasin',
      ],
    },
    'b2b-distribution': {
      name: 'Distribution B2B & grossiste',
      tagline: 'Conçu pour la distribution',
      headline: 'Logiciel de livraison du',
      headlineHighlight: 'DC au client',
      description:
        'Tournées multi-arrêts vers détaillants et chantiers avec POD, fenêtres de quai et analytics pour ops et finance, sans tableurs.',
      heroKeyPoints: [
        'Routes multi-arrêts palettes & SKU',
        'POD digital signature, photo, horodatage',
        'Visibilité type expéditeur pour comptes clés',
        'Reporting coût par livraison et coût de service',
      ],
      stats: [
        { value: '22%', label: 'Coût par livraison en baisse' },
        { value: '99%', label: 'Capture POD' },
        { value: '2×', label: 'Arrêts par shift' },
      ],
      painPoints: [
        { title: 'Dispatch dans les feuilles', description: 'Les planificateurs envoient des PDF, les chauffeurs improvisent.' },
        { title: 'Chaos quai & fenêtre', description: 'Créneaux manqués = pénalités et perte de confiance.' },
        { title: 'Pas d’économie unitaire', description: 'Carburant, temps et retours non liés à la rentabilité client/lane.' },
      ],
      features: [
        { title: 'Routage sensible à la charge', description: 'Séquence par poids, cube et type d’essieu.', tag: 'IA' },
        { title: 'Fenêtres rendez-vous', description: 'Arrivées magasin/chantier avec tampon et alertes retard.' },
        { title: 'POD entreprise', description: 'Signature, photo, confirmation ligne par ligne.' },
        { title: 'Portails compte', description: 'Grands clients voient statut et documents sans appeler.' },
        { title: 'Analytics lanes', description: '€/km, attente et ponctualité par route, hub, tier.' },
        { title: 'Workflows exceptions', description: 'Refus, partiels, relivraisons avec ownership clair.' },
        { title: 'Hooks ERP & WMS', description: 'Commandes et POD vers le système de référence.' },
        { title: 'Tour de contrôle', description: 'Une carte : camions actifs, retards, exceptions ouvertes.' },
      ],
      useCases: [
        'Redistribution foodservice',
        'Distributeurs de boissons',
        'Fourgons fournitures industrielles',
        'Papier & emballage',
        'Sortie DC régionale',
        'Dernier segment cash & carry',
      ],
    },
    'medical-supplies': {
      name: 'Fournitures médicales & laboratoires',
      tagline: 'Conçu pour la log médicale',
      headline: 'Logistique prélèvements, kits & supplies avec',
      headlineHighlight: 'fenêtres & preuve',
      description:
        'Enlèvements et livraisons pour labs, cliniques et dispositifs avec fenêtres strictes, traçabilité type chaîne de possession et preuve auditable.',
      heroKeyPoints: [
        'Planification critique enlèvement/livraison',
        'Checklists chauffeur intégrité kit & température',
        'Traçabilité complète pour audits',
        'Notifications client avec ETA live',
      ],
      stats: [
        { value: '99,2%', label: 'Respect des fenêtres' },
        { value: '100%', label: 'Piste digitale' },
        { value: '30%', label: 'Moins de relivraisons' },
      ],
      painPoints: [
        { title: 'SLA prélèvement labo', description: 'Fenêtre manquée invalide la tournée — le téléphone ne scale pas.' },
        { title: 'Audit & responsabilité', description: 'Sans horodatage et signature, les enquêtes tournent au blâme.' },
        { title: 'Multi-sites', description: 'Hôpitaux, cliniques et dépôts, règles et quais différents.' },
      ],
      features: [
        { title: 'Routage fenêtre', description: 'Contraintes dures et souples pour agendas labo et cliniques.', tag: 'IA' },
        { title: 'POD type chaîne de possession', description: 'Scan, scellé, signature, photo défendables en revue.' },
        { title: 'Sensibilité froid', description: 'Marque et séquence les segments sensibles avec max temps transit.' },
        { title: 'Alertes parties prenantes', description: 'Labo et clinique notifiés enlèvement, retard, livraison.' },
        { title: 'Boucles enlèvement + livraison', description: 'Optimise prélèvements et réapprovisionnement dans un plan.', tag: 'IA' },
        { title: 'Workflows chauffeur', description: 'Étapes guidées pour nouveaux chauffeurs conformes.' },
        { title: 'Analytics conformité', description: '% enlèvement à l’heure, raisons d’exception, attente par site.' },
        { title: 'Adjacent LIS / EMR', description: 'Flux commandes et statut depuis stacks santé courants.' },
      ],
      useCases: [
        'Messagerie prélèvements diagnostics',
        'Livraison stock médico-chirurgical',
        'Livraisons soins à domicile',
        'Logistique kits essais cliniques',
        'Fournitures dentaires & imagerie',
        'Segments froid biotech',
      ],
    },
    'field-service': {
      name: 'Service terrain',
      tagline: 'Conçu pour le terrain',
      headline: 'Rendez-vous, pièces & camions dans',
      headlineHighlight: 'un seul dispatch',
      description:
        'Tableaux journaliers HVAC, facilities, télécom et industrie : compétences, pièces, SLA et ETA client alignés CRM/FSM.',
      heroKeyPoints: [
        'Matching compétences & certifications',
        'Pièces sur camion pour premier passage réussi',
        'ETAs client qui se resserrent dans la journée',
        'Photo & signature par ordre de travail',
      ],
      stats: [
        { value: '18%', label: 'Plus d’interventions/tech/jour' },
        { value: '92%', label: 'Succès premier passage' },
        { value: '40%', label: 'Moins de « où êtes-vous ? »' },
      ],
      painPoints: [
        { title: 'Mauvais tech sur site', description: 'Certif ou outil oublié = second déplacement.' },
        { title: 'Pièce pas sur le camion', description: 'L’OT est planifiée mais l’inventaire n’était pas lié à la route.' },
        { title: 'Stress client', description: 'Créneaux serrés sans ETA live = lapins et plaintes.' },
      ],
      features: [
        { title: 'Affectation par compétences', description: 'OT ↔ tech par skill, zone, shift.', tag: 'IA' },
        { title: 'Lien pièces', description: 'Réserve ou prépare pièces sur la route.' },
        { title: 'ETAs dynamiques', description: 'Mise à jour propriétaire / facility si le jour glisse.', tag: 'IA' },
        { title: 'Carte live dispatch', description: 'Tous les techs, statut OT, risque retard.' },
        { title: 'POD ordre de travail', description: 'Photos avant/après, signatures, notes.' },
        { title: 'Optimisation RDV', description: 'Regroupement géographique dans les créneaux promis.' },
        { title: 'Métriques utilisation', description: 'Heures facturables, ratio route, SLA par équipe.' },
        { title: 'Prêt CRM / FSM', description: 'Sync jobs, statut, clôture.' },
      ],
      useCases: [
        'Install & maintenance CVC',
        'Maintenance bâtiments',
        'Techniciens télécom terrain',
        'Service équipements industriels',
        'Install smart home & sécurité',
        'Nuisibles & services immo',
      ],
    },
    'building-supplies': {
      name: 'Matériaux & charges volumineuses',
      tagline: 'Conçu pour le volumineux',
      headline: 'Tournées lourdes & volumineuses avec',
      headlineHighlight: 'fenêtres & preuve',
      description:
        'Bois, portes, sacs et livraisons chantier avec routage véhicule, fenêtres et POD photo tenable en litige.',
      heroKeyPoints: [
        'Routage par classe camion et temps de service réalistes',
        'Contact chantier & code portail sur l’arrêt',
        'Photos dommages & placement',
        'Groupement commandes par zone et règles grue/chariot',
      ],
      stats: [
        { value: '25%', label: 'Moins de relivraisons' },
        { value: '95%', label: 'Fenêtres tenues' },
        { value: '20%', label: 'Carburant / tonne en baisse' },
      ],
      painPoints: [
        { title: 'Mauvais véhicule pour la charge', description: 'Plateau vs fourgon = échec et heures sup.' },
        { title: 'Accès chantier chaotique', description: 'Chauffeur sans code, contact ou consignes de déchargement.' },
        { title: 'Litiges dommages', description: 'Sans photos, les « c’était déjà comme ça » mangent la marge.' },
      ],
      features: [
        { title: 'Profils véhicule', description: 'Capacité, hauteur, temps déchargement par famille SKU.', tag: 'IA' },
        { title: 'Fenêtres chantier', description: 'Matin uniquement ou créneaux grue avec marge.' },
        { title: 'Instructions chantier', description: 'Contacts, codes, risques visibles dans l’app.' },
        { title: 'POD déchargement', description: 'Série photos + signature liées ligne & horodatage.' },
        { title: 'Routes lourdes multi-arrêts', description: 'Séquence pour moins de rechargement et demi-tours.', tag: 'IA' },
        { title: 'Chemins d’exception', description: 'Refus, partiel, relivraison avec alerte dispatch.' },
        { title: 'Analytics tonne-mile', description: 'Coût et temps par tonne par agence et type client.' },
        { title: 'Sync commandes ERP', description: 'Tire les livraisons ouvertes, pousse le statut.' },
      ],
      useCases: [
        'Négoce bois & matériaux',
        'Portes & fenêtres',
        'Ciment & granulats sac',
        'Toiture & isolation',
        'Livraison location d’outil',
        'Runs pro desk vers artisans',
      ],
    },
    'automotive-parts': {
      name: 'Pièces automobile',
      tagline: 'Conçu pour les pièces',
      headline: 'Pièces jour même & ligne concession avec',
      headlineHighlight: 'routage prioritaire',
      description:
        'Urgences concession, atelier et retail avec priorités, cutoffs et tracking pour VOR et promesses de service.',
      heroKeyPoints: [
        'Priorité VOR & rush dans le solveur',
        'Engagements horaires atelier & concession',
        'Scan vérif enlèvement & remise',
        'Board après heures & samedi',
      ],
      stats: [
        { value: '45 min', label: 'Jambe urgente moyenne' },
        { value: '98%', label: 'Concession à l’heure' },
        { value: '15%', label: 'Km économisés' },
      ],
      painPoints: [
        { title: 'Panique VOR', description: 'Chaque urgence casse le plan et le planner refait à la main.' },
        { title: 'Mauvaise pièce au quai', description: 'L’erreur apparaît en concession — crédibilité en baisse.' },
        { title: 'Glissement cutoff', description: '« Avant midi » se dégrade si la matinée est opaque.' },
      ],
      features: [
        { title: 'Niveaux de priorité', description: 'VOR, jour même, standard avec pondération solveur.', tag: 'IA' },
        { title: 'Scan vérif', description: 'SKU & emplacement enlèvement, rescan à la concession.' },
        { title: 'Optim intra-ville', description: 'Boucles concession denses, moins de vide.', tag: 'IA' },
        { title: 'Comms concession', description: 'SMS & mail avec ETA live et motif retard.' },
        { title: 'Tracking marque', description: 'Pages OEM ou distributeur pour comptes premium.' },
        { title: 'POD exception', description: 'Refus ou partiel documenté en photo.' },
        { title: 'Tableaux SLA', description: 'Ponctualité par tier concession, famille SKU, chauffeur.' },
        { title: 'Hooks DMS / IMS', description: 'Commandes pièces et accusés vers inventaire.' },
      ],
      useCases: [
        'Programmes nuit OEM',
        'Appro atelier indépendant',
        'Fourgons pneus gros',
        'Accessoires jour même',
        'Urgences carrosserie',
        'Dépôts flotte',
      ],
    },
    'contract-logistics': {
      name: '3PL & logistique sous contrat',
      tagline: 'Conçu pour le 3PL',
      headline: 'Logistique multi-expéditeurs avec',
      headlineHighlight: 'portails & SLA',
      description:
        'Transport dédié et mutualisé pour plusieurs expéditeurs avec visibilité cloisonnée, ETAs type transporteur et analytics crédibles pour vos clients.',
      heroKeyPoints: [
        'Tracking de marque & SLA par expéditeur',
        'Planification hubs & ligne troncale',
        'Réclamations & exceptions auditables',
        'Marge & coût de service par compte',
      ],
      stats: [
        { value: '30%', label: 'Moins d’admin statut' },
        { value: '99%', label: 'Adoption tracking' },
        { value: '2×', label: 'Onboarding plus rapide' },
      ],
      painPoints: [
        { title: 'Surcharge visibilité', description: 'L’ops répond « où c’est ? » en boucle.' },
        { title: 'SLA flous', description: 'Le contrat promet des niveaux que l’outil ne mesure pas.' },
        { title: 'Angles morts marge', description: 'Volume gagné, argent perdu sur des lanes non modélisées.' },
      ],
      features: [
        { title: 'Visibilité multi-locataire', description: 'Chaque expéditeur ne voit que son fret, marque lui ou vous.' },
        { title: 'Routage réseau', description: 'Hubs, ligne troncale & dernier km avec vues par rôle.', tag: 'IA' },
        { title: 'Monitoring SLA', description: 'Alertes avant rupture avec actions de récupération.' },
        { title: 'Événements auditables', description: 'Statut, POD, comms horodatés par segment.' },
        { title: 'Économie par compte', description: 'Revenu, coût, marge par client et lane.' },
        { title: 'Self-serve expéditeur', description: 'Booking, docs, carte live sans ping-pong mail.' },
        { title: 'Scorecards dirigeants', description: 'Ponctualité, coût par commande, qualité par grand contrat.' },
        { title: 'API d’abord', description: 'Injection commandes et événements vers TMS, WMS, SI expéditeur.' },
      ],
      useCases: [
        'Transport régional sous contrat',
        '3PL e-commerce fulfillment',
        'Flotte dédiée industrielle',
        'Segments 3PL froid',
        'Consolidation inbound retail',
        'Dernier km marque blanche',
      ],
    },
  },
};
